const contactTransformationHelper = (data) => {
  data.body.contacts = [];
  return data;
};

export { contactTransformationHelper };